export default "__VITE_ASSET__a02a2067__"